import React from "react";
import styles from "./Carna.module.css";

import Carna01 from "../../../assets/brochure/carna/Carna_01.png";
import Carna02Chair from "../../../assets/brochure/carna/Carna_02.png";

import WaveModule from "../../../assets/brochure/carna/Asset 2.webp";
import WaveProgram from "../../../assets/brochure/carna/Asset 3.webp";
import XdAir from "../../../assets/brochure/carna/Asset 4.webp";
import CompactChair from "../../../assets/brochure/carna/Asset 5.webp";
import SizeEveryone from "../../../assets/brochure/carna/Asset 6.webp";

import Asset7 from "../../../assets/brochure/carna/Asset 7.webp";
import Asset8 from "../../../assets/brochure/carna/Asset 8.webp";

import Asset11 from "../../../assets/brochure/carna/Asset 11.webp";
import Asset12 from "../../../assets/brochure/carna/Asset 12.webp";
import Asset13 from "../../../assets/brochure/carna/Asset 13.webp";
import Asset14 from "../../../assets/brochure/carna/Asset 14.webp";
import Asset15 from "../../../assets/brochure/carna/Asset 15.webp";
import Asset16 from "../../../assets/brochure/carna/Asset 16.webp";

import Asset18 from "../../../assets/brochure/carna/Asset 18.webp";

import Asset20 from "../../../assets/brochure/carna/Asset 20.webp";

import Asset22 from "../../../assets/brochure/carna/Asset 22.webp";
import Asset24 from "../../../assets/brochure/carna/Asset 24.webp";

import Carna09 from "../../../assets/brochure/carna/Carna_09.png";

import Asset26 from "../../../assets/brochure/carna/Asset 26.webp";
import Asset27 from "../../../assets/brochure/carna/Asset 27.webp";
import Asset28 from "../../../assets/brochure/carna/Asset 28.webp";
import Asset29 from "../../../assets/brochure/carna/Asset 29.webp";
import Asset30 from "../../../assets/brochure/carna/Asset 30.webp";
import Asset31 from "../../../assets/brochure/carna/Asset 31.webp";
import Asset32 from "../../../assets/brochure/carna/Asset 32.webp";
import Asset33 from "../../../assets/brochure/carna/Asset 33.webp";
import Asset34 from "../../../assets/brochure/carna/Asset 34.webp";
import Asset35 from "../../../assets/brochure/carna/Asset 35.webp";
import Asset36 from "../../../assets/brochure/carna/Asset 36.webp";
import Asset37 from "../../../assets/brochure/carna/Asset 37.webp";

import Asset39 from "../../../assets/brochure/carna/Asset 39.webp";
import Asset40 from "../../../assets/brochure/carna/Asset 40.webp";
import Asset41 from "../../../assets/brochure/carna/Asset 41.webp";
import Asset42 from "../../../assets/brochure/carna/Asset 42.webp";
import Asset43 from "../../../assets/brochure/carna/Asset 43.webp";
import Asset44 from "../../../assets/brochure/carna/Asset 44.webp";

import Asset46 from "../../../assets/brochure/carna/Asset 46.webp";

import Asset47 from "../../../assets/brochure/carna/Asset 47.webp";
import Asset48 from "../../../assets/brochure/carna/Asset 48.webp";
import Asset49 from "../../../assets/brochure/carna/Asset 49.webp";
import Asset50 from "../../../assets/brochure/carna/Asset 50.webp";
import Asset51 from "../../../assets/brochure/carna/Asset 51.webp";
import Asset52 from "../../../assets/brochure/carna/Asset 52.webp";

import Carna14 from "../../../assets/brochure/carna/Carna_14.jpg";

const recommendations = [
  <>
    I want to cool down <strong>my pelvis</strong> because I sit for a long time.
  </>,
  <>
    We are a short wife and a tall husband. We want to use it{" "}
    <strong>just right for all of us.</strong>
  </>,
  <>
    I need a massage chair{" "}
    <strong>that is small in size yet has full breadth of functions.</strong>
  </>,
  <>
    I want it to blend into the space with a <strong>simple design.</strong>
  </>,
  <>
    I like warm and soft <strong>fabric textures.</strong>
  </>,
];

const massagePrograms = [
  {
    icon: Asset27,
    title: "WAVE CARE",
    isNew: true,
    description:
      "Woman’s Mode, Man’s Mode,\nPerineal Massage, and Sphincter Massage",
  },
  {
    icon: Asset28,
    title: "DAILY CARE",
    isNew: false,
    description:
      "Deep Sleep, Pre/Post Workout, Morning\nVitality, and Digestive Health",
  },
  {
    icon: Asset29,
    title: "BODY PARTS CARE",
    isNew: false,
    description:
      "Full Body, Neck/Shoulders, Waist/Butt,\nand Feet/Legs",
  },
];

const healthcareModes = [
  {
    icon: Asset30,
    title: "QUEENS RELAX",
    isNew: true,
    description:
      "This massage gently kneads and stimulates\nacupuncture points associated with\nmenstruation to help relaxation.",
  },
  {
    icon: Asset31,
    title: "GRAND SENIOR",
    isNew: true,
    description:
      "This massage provides energy and vitality\nto seniors with gentle full-body relaxation.",
  },
  {
    icon: Asset32,
    title: "FULL BODY STRETCH",
    isNew: false,
    description: "This massage applies cool stretches to\nthe full body.",
  },
  {
    icon: Asset33,
    title: "NAPE TENSION RELIEF",
    isNew: false,
    description: "This massage relaxes occipital and nape\nmuscles.",
  },
  {
    icon: Asset34,
    title: "SPINE MODE",
    isNew: false,
    description:
      "This massage provides spine mode\nacupressure centered on the back and waist.",
  },
  {
    icon: Asset35,
    title: "HANGOVER RELIEF",
    isNew: false,
    description:
      "This massage applies acupressure on\nstimulation points that help relieve hangovers.",
  },
  {
    icon: Asset36,
    title: "STIFFNESS RELIEF",
    isNew: false,
    description:
      "This massage helps relieve stiffness with\nfull-body airbags.",
  },
  {
    icon: Asset37,
    title: "SWELLING RELIEF",
    isNew: false,
    description:
      "This massage uses full-body airbags to\nrelieve swelling.",
  },
];

const Carna = () => {
  return (
    <article className={styles.carnaBrochure}>
      
      <section className={styles.heroSection}>
        <img
          src={Carna01}
          alt="CARNA Secret Wave Care massage chair"
          className={styles.heroImage}
        />
      </section>

      
      <section
        className={styles.recommendSection}
        aria-labelledby="carna-recommend-title"
      >
        <header className={styles.recommendHeader}>
          <span className={styles.recommendBadge}>RECOMMEND</span>

          <h2 id="carna-recommend-title" className={styles.recommendTitle}>
            CARNA’S SECRET WAVE CARE
          </h2>

          <p className={styles.recommendSubtitle}>
            BECOMES MORE DELICATE WITH THE VIBRATION MODULE.
          </p>

          <p className={styles.recommendQuote}>
            “RECOMMENDING IT TO THESE PEOPLE.”
          </p>
        </header>

        <div className={styles.chairImageWrap}>
          <img
            src={Carna02Chair}
            alt="CARNA compact massage chair in soft grey fabric"
            className={styles.chairImage}
            loading="lazy"
          />
        </div>

        <div className={styles.recommendList}>
          {recommendations.map((text, index) => (
            <div className={styles.recommendItem} key={index}>
              <span className={styles.checkCell} aria-hidden="true">
                ✓
              </span>
              <p>{text}</p>
            </div>
          ))}
        </div>
      </section>

      
      <section className={styles.page03} aria-labelledby="carna-page03-title">
        <h2 id="carna-page03-title" className={styles.visuallyHidden}>
          CARNA product key points
        </h2>

        <div className={styles.point01Row}>
          <img
            src={WaveModule}
            alt="CARNA wave massage module"
            className={styles.point01Image}
            loading="lazy"
          />
          <div className={styles.point01Text}>
            <span className={styles.pointLabel}>POINT 01</span>
            <h3>WAVE MASSAGE MODULE</h3>
            <p>
              SPECIALIZED FOR PELVIC
              <br />
              FLOOR MUSCLE CARE
            </p>
          </div>
        </div>

        <div className={styles.point02Block}>
          <img
            src={WaveProgram}
            alt="Woman using the CARNA wave massage program"
            className={styles.point02Image}
            loading="lazy"
          />
          <div className={styles.point02Text}>
            <span className={styles.pointLabel}>POINT 02</span>
            <p>
              SECRET! <strong>THE WAVE MASSAGE PROGRAM</strong> HELPS
              <br />
              CARE FOR PERINEAL AND PELVIC MUSCLES.
            </p>
          </div>
        </div>

        <div className={styles.point03Block}>
          <img
            src={XdAir}
            alt="CARNA XD air massage module mechanism"
            className={styles.point03Image}
            loading="lazy"
          />
          <span className={styles.pointLabel}>POINT 03</span>
          <p>
            THE XD AIR MODULE CONTROLS SMOOTHER AND
            <br />
            MORE DIMENSIONAL DEPTH BY LEVELS 1 TO 5.
          </p>
        </div>

        <div className={styles.point04Row}>
          <img
            src={CompactChair}
            alt="CARNA compact massage chair in a modern room"
            className={styles.point04Image}
            loading="lazy"
          />
          <div className={styles.point04Text}>
            <span className={styles.pointLabel}>POINT 04</span>
            <h3>DOWNSIZED MASSAGE CHAIR</h3>
            <p>WITH A SLIM AND COMPACT DESIGN</p>
          </div>
        </div>

        <div className={styles.point05Block}>
          <img
            src={SizeEveryone}
            alt="Woman relaxing in the CARNA massage chair"
            className={styles.point05Image}
            loading="lazy"
          />
          <div className={styles.point05Text}>
            <span className={styles.pointLabel}>POINT 05</span>
            <h3>A SIZE THAT FITS EVERYONE,</h3>
            <p>NO MATTER HOW TALL OR SHORT</p>
          </div>
        </div>
      </section>

      
      <section className={styles.page04} aria-labelledby="carna-page04-title">
        <header className={styles.page04Header}>
          <span className={styles.page04Badge}>POINT 01</span>

          <h2 id="carna-page04-title">WAVE MASSAGE MODULE</h2>

          <p>SPECIALIZED FOR PELVIC FLOOR MUSCLE CARE</p>
        </header>

<img
  src={Asset7}
  alt="Woman using the CARNA wave massage module"
  className={styles.page04MainImage}
  loading="lazy"
/>

<img
  src={Asset8}
  alt="CARNA pelvic vibration module"
  className={styles.page04ModuleImage}
  loading="lazy"
/>

        <div className={styles.page04Description}>
          <p>
            The pelvic vibration frequency of the seat and
          
          
            perineal airbag massage <strong>help care for the
          
          
            pelvic floor muscles</strong> and induce natural Kegel
          
          exercises.</p>
        </div>

        <aside className={styles.page04Note}>
          <p>
            ※ The pelvic floor muscles are those that make up the bottom of the
            pelvis and are important for protecting and supporting the lower
            abdominal organs, including the bladder, uterus, and rectum.
          </p>
          <p>
            They are heavily involved in contracting and relaxing the anus,
            urethra, and genitals, and are especially important during
            childbirth in women.
          </p>
        </aside>
      </section>

      
<section
  className={styles.page05}
  aria-labelledby="carna-page05-title"
>
  <header className={styles.page05Header}>
    <span className={styles.page05Badge}>POINT 02</span>

    <p className={styles.page05Secret}>SECRET!</p>

    <h2 id="carna-page05-title">
      THE WAVE MASSAGE PROGRAM
    </h2>

    <p className={styles.page05Subtitle}>
      helps care for perineal and pelvic muscles.
    </p>

    <p className={styles.page05Warning}>
      ※ 임산부는 웨이브 케어의 사용을 자제 바랍니다. ※
    </p>
  </header>

  
  <div className={styles.page05ModeCard}>
    <div className={styles.page05ModeImageWrap}>
      <img
        src={Asset11}
        alt="Woman using CARNA Woman's Mode"
        className={styles.page05ModeImage}
        loading="lazy"
      />
    </div>

    <div className={styles.page05ModeContent}>
      <h3>
        WOMAN’S
        <br />
        MODE
      </h3>

      <img
        src={Asset12}
        alt=""
        aria-hidden="true"
        className={styles.page05ModeIcon}
        loading="lazy"
      />

      <p>
        This mode delivers vibration stimulation to the entire pelvis to
        induce repetitive contraction and relaxation, helping to{" "}
        <strong>care for the pelvic floor muscles.</strong>
      </p>
    </div>
  </div>

  
  <div className={styles.page05ModeCard}>
    <div className={styles.page05ModeImageWrap}>
      <img
        src={Asset13}
        alt="Man using CARNA Man's Mode"
        className={styles.page05ModeImage}
        loading="lazy"
      />
    </div>

    <div className={styles.page05ModeContent}>
      <h3>
        MAN’S
        <br />
        MODE
      </h3>

      <img
        src={Asset14}
        alt=""
        aria-hidden="true"
        className={styles.page05ModeIcon}
        loading="lazy"
      />

      <p>
        This mode delivers vibration stimulation to the entire pelvis and
        helps <strong>stimulate the muscles around the prostate</strong> in
        consideration of the male body structure and characteristics.
      </p>
    </div>
  </div>

  
  <div className={styles.page05ModeCard}>
    <div className={styles.page05ModeImageWrap}>
      <img
        src={Asset15}
        alt="CARNA perineal sphincter massage module"
        className={styles.page05ModeImage}
        loading="lazy"
      />
    </div>

    <div className={styles.page05ModeContent}>
      <p className={styles.page05Advanced}>| Advanced Mode |</p>

      <h3 className={styles.page05PerinealTitle}>
        PERINEAL
        <br />
        SPHINCTER MASSAGE
      </h3>

      <img
        src={Asset16}
        alt=""
        aria-hidden="true"
        className={styles.page05PerinealIcon}
        loading="lazy"
      />

      <p>
        This mode uses vibration stimulation to induce pelvic floor
        contraction and relaxation exercises, such as Kegel exercises, to
        help with <strong>sphincter intensive care.</strong>
      </p>
    </div>
  </div>

  <div className={styles.page05BottomText}>
    <p>
      The pelvic muscles are one of the four core muscles of the body. CARNA{" "}
      <strong>helps with perineal and pelvic muscle care</strong> with wave
      massage of the airbags and vibration module applied to the seat.
    </p>
  </div>
</section>


<section
  className={styles.page06}
  aria-labelledby="carna-page06-title"
>
  <header className={styles.page06Header}>
    <span className={styles.page06Badge}>POINT 03</span>

    <p className={styles.page06Eyebrow}>
      GENTLER! SOMETIMES HARDER!
    </p>

    <h2 id="carna-page06-title">
      EVOLVED XD AIR MODULE
    </h2>
  </header>

  <img
    src={Asset18}
    alt="CARNA evolved XD air massage module"
    className={styles.page06Image}
    loading="lazy"
  />

  <div className={styles.page06Description}>
    <p>
      The airbag applied to the massage module controls the roller depth
      effectively, allowing you to feel{" "}
      <strong>
        a more gentle pushing and pulling massage sensation.
      </strong>
    </p>
  </div>
</section>


<section
  className={styles.page07}
  aria-labelledby="carna-page07-title"
>
  <header className={styles.page07Header}>
    <span className={styles.page07Badge}>POINT 04</span>

    <h2 id="carna-page07-title">
      DOWNSIZED MASSAGE CHAIR
    </h2>

    <p>WITH A SLIM AND COMPACT DESIGN</p>
  </header>

  <img
    src={Asset20}
    alt="CARNA downsized massage chair with a slim and compact design"
    className={styles.page07Image}
    loading="lazy"
  />

  <div className={styles.page07Description}>
    <p>
      Compared to the basic size of the Company’s<br />
      existing products, it is <strong>downsized by 23% to<br />
      reduce space constraints greatly.</strong>
    </p>
  </div>
</section>


<section className={styles.page08} aria-labelledby="carna-page08-title">

  <header className={styles.page08Header}>
    <span className={styles.page08Badge}>POINT 05</span>

    <h2 id="carna-page08-title">
      A SIZE THAT FITS EVERYONE,
    </h2>

    <h3>NO MATTER HOW TALL OR SHORT</h3>

    <p>
      The form factor has been developed
      <br />
      and applied so that both short and tall people can
      <br />
      sit comfortably, with a recommended height of
      <br />
      155 to 185cm, so <strong>the whole family can use it satisfactorily.</strong>
    </p>
  </header>

  <img
    src={Asset22}
    alt=""
    className={styles.page08ImageTop}
  />

  <div className={styles.page08Divider}>
    <span>+</span>
  </div>

  <img
    src={Asset24}
    alt=""
    className={styles.page08ImageBottom}
  />

  <section className={styles.page08BottomText}>
    <h2>PRECISE LEG MASSAGER LENGTH ADJUSTMENT</h2>

    <p>
      Having gone through extensive usability evaluation,
      <br />
      CARNA precisely controls the length of the leg massager
      <br />
      according to the user's physical condition,
      greatly improving
      <br />
      the massage sensation of the calves and soles.
    </p>
  </section>

</section>


<section className={styles.page09}>
  <img
    src={Carna09}
    alt="CARNA Brochure Page 09"
    className={styles.page09Image}
    loading="lazy"
  />
</section>


<section
  className={styles.page10}
  aria-labelledby="carna-page10-title"
>
  <header className={styles.page10Header}>
    <p className={styles.page10Eyebrow}>Function</p>

    <h2 id="carna-page10-title">
      CARNA’S
      <br />
      VARIOUS FUNCTIONS
    </h2>

    <p className={styles.page10Subtitle}>
      REALIZED BY BODYFRIEND’S TECHNOLOGY
    </p>

    <span className={styles.page10Number}>01</span>
  </header>

  <img
    src={Asset26}
    alt="Woman relaxing in the CARNA massage chair"
    className={styles.page10MainImage}
    loading="lazy"
  />

  <div className={styles.page10Content}>
    
    <section
      className={styles.page10ProgramSection}
      aria-labelledby="carna-massage-programs"
    >
      <h3 id="carna-massage-programs">
        12 MASSAGE PROGRAMS
      </h3>

      <div className={styles.page10List}>
        {massagePrograms.map((program) => (
          <article
            className={styles.page10ListItem}
            key={program.title}
          >
            <img
              src={program.icon}
              alt=""
              aria-hidden="true"
              className={styles.page10Icon}
              loading="lazy"
            />

            <div className={styles.page10ItemText}>
              <h4>
                {program.title}

                {program.isNew && (
                  <span className={styles.page10NewBadge}>
                    NEW
                  </span>
                )}
              </h4>

              <p>{program.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>

    
    <section
      className={styles.page10HealthcareSection}
      aria-labelledby="carna-healthcare-modes"
    >
      <h3 id="carna-healthcare-modes">
        8 HEALTHCARE MODES
      </h3>

      <div className={styles.page10List}>
        {healthcareModes.map((mode) => (
          <article
            className={styles.page10ListItem}
            key={mode.title}
          >
            <img
              src={mode.icon}
              alt=""
              aria-hidden="true"
              className={styles.page10Icon}
              loading="lazy"
            />

            <div className={styles.page10ItemText}>
              <h4>
                {mode.title}

                {mode.isNew && (
                  <span className={styles.page10NewBadge}>
                    NEW
                  </span>
                )}
              </h4>

              <p>{mode.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  </div>
</section>


<section
  className={styles.page11}
  aria-labelledby="carna-page11-title"
>
  <header className={styles.page11Header}>
    <span className={styles.page11Number}>02</span>

    <h2 id="carna-page11-title">
      AIRBAG AND ROLLER MASSAGE,
    </h2>

    <p>THOROUGHLY COOLING THE WHOLE BODY</p>
  </header>

  
  <div className={styles.page11FeatureTop}>
    <img
      src={Asset40}
      alt="CARNA full-body airbag massage"
      className={styles.page11TopImage}
      loading="lazy"
    />

    <div className={styles.page11TopCard}>
      <img
        src={Asset39}
        alt=""
        aria-hidden="true"
        className={styles.page11CardIcon}
        loading="lazy"
      />

      <p>
        50 full-body <strong>airbags</strong>
      </p>

      <p>cover your body completely.</p>
    </div>
  </div>

  
  <div className={styles.page11FeatureMiddle}>
    <img
      src={Asset41}
      alt="CARNA calf and sole roller massage"
      className={styles.page11MiddleImage}
      loading="lazy"
    />

    <div className={styles.page11MiddleCard}>
      <img
        src={Asset42}
        alt=""
        aria-hidden="true"
        className={styles.page11CardIcon}
        loading="lazy"
      />

      <p>
        Cooling to the end
        <br />
        with <strong>rollers</strong> for calves
        <br />
        and soles
      </p>
    </div>
  </div>

  
  <div className={styles.page11FeatureBottom}>
    <img
      src={Asset44}
      alt="Woman using the CARNA heating function"
      className={styles.page11BottomImage}
      loading="lazy"
    />

    <div className={styles.page11BottomCard}>
      <img
        src={Asset43}
        alt=""
        aria-hidden="true"
        className={styles.page11CardIcon}
        loading="lazy"
      />

      <p>
        <strong>Heating function</strong>
      </p>

      <p>
        for a warm and
        <br />
        comfortable massage
      </p>
    </div>
  </div>
</section>


<section
  className={styles.page12}
  aria-labelledby="carna-page12-title"
>
  <span className={styles.page12Number}>03</span>

  <img
    src={Asset46}
    alt="CARNA pinch prevention sensor system"
    className={styles.page12Image}
    loading="lazy"
  />

  <div className={styles.page12Content}>
    <h2 id="carna-page12-title">
      12 PINCH PREVENTION SENSORS
    </h2>

    <p>
      12 safety sensors are mounted to prevent objects from
      <br />
      getting stuck while operating the massage chair.
    </p>
  </div>
</section>


<section
  className={styles.page13}
  aria-labelledby="carna-page13-title"
>
  <header className={styles.page13Header}>
    <p className={styles.page13Eyebrow}>Convenient Function</p>

    <h2 id="carna-page13-title">
      CARNA’S CONVENIENCE FEATURES
    </h2>

    <p className={styles.page13Subtitle}>
      FOR FURTHER SATISFACTORY
      <br />
      RELAXATION
    </p>
  </header>

  <div className={styles.page13Features}>
    
    <article className={styles.page13Feature}>
      <div className={styles.page13ImageWrap}>
        <img
          src={Asset47}
          alt="CARNA touch screen remote control"
          className={styles.page13Image}
          loading="lazy"
        />
      </div>

      <div className={styles.page13Text}>
        <p className={styles.page13AccentText}>
          INTUITIVELY OPERATING
        </p>

        <h3>
          5” TOUCH SCREEN
          <br />
          REMOTE CONTROL
        </h3>

        <p>
          <strong>Intuitive UI structure</strong> that is visible at a glance
          facilitates easy and quick control.
        </p>
      </div>
    </article>

    
    <article
      className={`${styles.page13Feature} ${styles.page13FeatureReverse}`}
    >
      <div className={styles.page13ImageWrap}>
        <img
          src={Asset48}
          alt="CARNA automatic body shape recognition system"
          className={styles.page13Image}
          loading="lazy"
        />
      </div>

      <div className={`${styles.page13Text} ${styles.page13TextRight}`}>
        <p className={styles.page13AccentText}>
          PROVIDING
          <br />
          CUSTOMIZED MASSAGE
        </p>

        <h3>
          AUTOMATIC BODY SHAPE
          <br />
          RECOGNITION SYSTEM
        </h3>

        <p>
          <strong>The sensor detects your shoulder height</strong> to customize
          the massage to your body.
        </p>
      </div>
    </article>

    
    <article className={styles.page13Feature}>
      <div className={styles.page13ImageWrap}>
        <img
          src={Asset49}
          alt="CARNA swing sliding system"
          className={styles.page13Image}
          loading="lazy"
        />
      </div>

      <div className={styles.page13Text}>
        <p className={styles.page13AccentText}>
          EASY TO USE SPACE
        </p>

        <h3>SWING SLIDING SYSTEM</h3>

        <p>
          Minimizes backspace required for installation for{" "}
          <strong>efficient space utilization.</strong>
        </p>
      </div>
    </article>

    
    <article
      className={`${styles.page13Feature} ${styles.page13FeatureReverse}`}
    >
      <div className={styles.page13ImageWrap}>
        <img
          src={Asset50}
          alt="CARNA automatic leg length adjustment"
          className={styles.page13Image}
          loading="lazy"
        />
      </div>

      <div className={`${styles.page13Text} ${styles.page13TextRight}`}>
        <p className={styles.page13AccentText}>
          PROVIDING
          <br />
          COMFORTABLE POSTURE
        </p>

        <h3>
          AUTOMATIC LEG LENGTH
          <br />
          ADJUSTMENT
        </h3>

        <p>
          Automatically adjusts the leg length to fit your body shape to provide
          a delicate and comfortable massage.
        </p>
      </div>
    </article>

    
    <article className={styles.page13Feature}>
      <div className={styles.page13ImageWrap}>
        <img
          src={Asset51}
          alt="CARNA Bluetooth connection feature"
          className={styles.page13Image}
          loading="lazy"
        />
      </div>

      <div className={styles.page13Text}>
        <p className={styles.page13AccentText}>
          MASSAGE AND LISTENING
          <br />
          MUSIC AT THE SAME TIME
        </p>

        <h3>BLUETOOTH CONNECTION</h3>

        <p>
          <strong>Connect your smartphone</strong> and listen to your favorite
          music in the massage chair.
        </p>
      </div>
    </article>

    
    <article
      className={`${styles.page13Feature} ${styles.page13FeatureReverse}`}
    >
      <div className={styles.page13ImageWrap}>
        <img
          src={Asset52}
          alt="CARNA USB charging port"
          className={styles.page13Image}
          loading="lazy"
        />
      </div>

      <div className={`${styles.page13Text} ${styles.page13TextRight}`}>
        <p className={styles.page13AccentText}>
          RELAX AND CHARGE YOUR
          <br />
          PHONE AT THE SAME TIME
        </p>

        <h3>USB CHARGING PORT</h3>

        <p>
          While relaxing in the massage chair, you can{" "}
          <strong>charge your smartphone.</strong>
        </p>
      </div>
    </article>
  </div>
</section>


<section className={styles.page14}>
  <img
    src={Carna14}
    alt="CARNA brochure final page"
    className={styles.page14Image}
    loading="lazy"
  />
</section>
    </article>

    
  );
  
};

export default Carna;
